import * as Constants from "../common/Constants";

const initialState = {
    salesData: [],
    currentEmployeeId: 0,
    isLoading: false,
    isPosting: false,
    isPosted: false,
    currentDistributor: null,
    //count: 0,
    //page: 1,
    //pageSize: 10,
    error: null
};

export default function salesDataReducer(state = initialState, action) {

    switch (action.type) {
        
        case Constants.REQUEST_ADD_SALES_DATA:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        case Constants.SUCCESS_ADD_SALES_DATA:
            var newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.FAILED_GET_DISTRIBUTOR:
        case Constants.FAILED_GET_SALES_DATA:
        case Constants.FAILED_ADD_SALES_DATA:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_GET_DISTRIBUTOR:
        case Constants.REQUEST_GET_SALES_DATA:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;
            //newState.filteredUsers = action.filteredUsers;
            return newState;

        case Constants.SUCCESS_GET_SALES_DATA:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.salesData = action.payload;
            newState.currentEmployeeId = (action.payload.length > 0) ? action.payload[0].salesPersonId : 0;
            //newState.page = action.payload.page;
            //newState.pageSize = action.payload.pageSize;
            //newState.count = action.payload.totalCount;
            return newState;

        case Constants.SUCCESS_GET_DISTRIBUTOR:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.currentDistributor = action.payload;
            return newState;

        case Constants.RESET_SALES_DATA:
            var newState = { ...state };
            newState.salesData = [];
            newState.currentEmployeeId = 0;
            newState.currentDistributor = null;
            newState.isLoading= false;
            newState.isPosting = false;
            newState.isPosted= false;
            newState.error= null;
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/SalesDataReducer.js